module.exports = __webpack_public_path__ + "7d7400f7b0cbd507430e85c7357ab8a9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/band-egyptian-s.png
// module id = 2770
// module chunks = 0